export default "__VITE_ASSET__B6PZ9Vkq__"